window.ReportError=
{
	dlg:null,
	stock_permalink:null,
	stock_name:null,
	init:function() {

        jQuery('#lnk_report_error').click(ReportError.show);
        jQuery('#cmd-report-error').click(function(){
                            jQuery('#frm-report-error').submit();
                        });

                    jQuery('#frm-report-error').submit(function(e){
                        jQuery('#report-error-alert').hide();
                        e.preventDefault();
                        var messages="";
                        if (jQuery('#comments').val() == "") {
                           messages+='Please enter your comments or concerns<br/>';
                        }
                        if (jQuery('#captcha').val() == "") {
                                                  messages+='Please type the code from the image<br/>';
                                               }
                        if (messages!=""){
                            jQuery('#report-error-alert').html(messages);
                            jQuery('#report-error-alert').show();
                            return false;
                        }
                        whalewisdom.Utilities.toggle_wait(true);
                        var form = jQuery( this );
                        url = form.attr( 'action' );
                        var params=form.serialize();
                        jQuery.post( url, {user_email:jQuery('#your_email').val(),

                                permalink:jQuery('#entity_permalink').val(),
                            user_name:jQuery('#user_name').val(),
                            'g-recaptcha-response':jQuery('#g-recaptcha-response').val(),
                            recaptcha_response_field:jQuery('#recaptcha_response_field').val(),
                            recaptcha_challenge_field:jQuery('#recaptcha_challenge_field').val(),
                               // captcha:jQuery('#captcha').val(),
                                comments:jQuery('#comments').val()},
                              function( data ) {
                                  jQuery('#dlg_report_error').modal('hide');
                                response = data.split("<!")[0];
                                //document.getElementById("reg_resp").innerHTML = response;
                                whalewisdom.Utilities.toggle_wait(false);
                                whalewisdom.Utilities.show_alert('Report an error',response);
                              },"text"
                            ).error(function(o) {
                                whalewisdom.Utilities.toggle_wait(false);
                                whalewisdom.Utilities.show_alert('There was a problem.',"Submission failed: " + o.responseText);
                            });
                       return false;
                });

		/*	}});
			loader.insert();*/
                        
		
	},
    show:function(){
            jQuery('#report-error-alert').hide();
            jQuery('#user_name').val('');
            jQuery('#your_email').val('');
            jQuery('#comments').val('');
        jQuery('#captcha').val('');
            jQuery('#dlg_report_error').modal({
            })
    		//EmailRegistration.dlg.show();
    	}
    /*
	show:function(){
		ReportError.dlg.show();
	}   */
}
jQuery(function () {
    ReportError.init();
});